/* eslint-disable no-nested-ternary */
import React, { useState } from 'react'
import ReactApexChart from 'react-apexcharts'
import { Box } from '@chakra-ui/react'

export default function DisplayBarGaugeAttribute({
  layout,
  staticData,
  stationData,
  attributeData,
  graphLabel,
  unit,
  highResolution,
  lowResolution,
  valueLable,
  diagramData,
}) {
  let sensorSourceData = []
  if (attributeData.dataSource === 'Sensor') {
    sensorSourceData = _.find(
      stationData?.sensors,
      (sensor) => sensor.refString === attributeData.sensorRef
    )
  } else if (attributeData.dataSource === 'Variable') {
    sensorSourceData = _.find(
      stationData?.variables,
      (varItem) => varItem._id === attributeData.variableId
    )
  }

  // console.log('sensorSourceData', attributeData)

  const series = [
    {
      data: [
        sensorSourceData?.numericStatus === null ||
        sensorSourceData?.numericStatus === undefined
          ? 0?.toFixed(0)
          : sensorSourceData?.numericStatus?.toFixed(0),
      ],
    },
  ]

  // const colorsRange = {
  //   yellowRange: lowResolution + (highResolution - lowResolution) * 0.8,
  //   redRange: lowResolution + (highResolution - lowResolution) * 0.9,
  // }
  const options = {
    chart: {
      type: 'bar',
    },
    colors: [attributeData?.barHorizontal ? '#005cff' : '#df0000'],
    plotOptions: {
      bar: {
        horizontal: attributeData?.barHorizontal || false,
        columnWidth: '100%',
        borderRadius: 1,
        borderRadiusApplication: 'end',
      },

      // labels: {
      //   formatter: (value) => {
      //     return parseFloat(value).toFixed(2)
      //   },
      // },
      yaxis: {
        labels: {
          formatter: (value) => {
            return parseFloat(value).toFixed(2)
          },
        },
        // min: (min) => min,
        // max: (max) => max,
        max: 100,
        min: 0,
      },

      dataLabels: {
        name: {
          show: true,
        },

        value: {
          show: true,
          formatter: (val) =>
            parseFloat(sensorSourceData?.numericStatus).toFixed(2) + ' ' + unit,
          offsetY: 5,
        },
      },
    },

    labels: [valueLable || ''],
  }

  if (sensorSourceData) {
    return (
      <ReactApexChart
        options={options}
        series={series}
        type="bar"
        height={attributeData?.barHorizontal ? layout?.h * 40 : layout?.h * 50}
      />
    )
  }
}
